import "core-js/modules/es.array.reduce-right.js";
import { useRef, useContext, useMemo, createElement } from 'react';
/* eslint-disable react-hooks/rules-of-hooks */

function useContextBridge() {
  for (var _len = arguments.length, contexts = new Array(_len), _key = 0; _key < _len; _key++) {
    contexts[_key] = arguments[_key];
  }

  var cRef = useRef([]);
  cRef.current = contexts.map(function (context) {
    return useContext(context);
  });
  return useMemo(function () {
    return function (_ref) {
      var children = _ref.children;
      return contexts.reduceRight(function (acc, Context, i) {
        return /*#__PURE__*/createElement(Context.Provider, {
          value: cRef.current[i],
          children: acc
        });
      }, children
      /*
       * done this way in reference to:
       * https://github.com/DefinitelyTyped/DefinitelyTyped/issues/44572#issuecomment-625878049
       * https://github.com/microsoft/TypeScript/issues/14729
       */
      );
    };
  }, []);
}

export { useContextBridge };